
/*
*
* File JS per la Archive News
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockTitle from 'components/block-title/block-title';
import heroSection from 'components/heroes/hero-section';
import mosaicoCards from 'components/mosaico-cards/mosaico-cards';
import blockText from 'components/block-text/block-text';
import blockService from 'components/block-service/block-service';
import blockCol2 from 'components/block-col2/block-col2';
import blockTabService from 'components/block-tab-service/block-tab-service';
import blockTabList from 'components/block-tab-list/block-tab-list';
import blockQuote from 'components/block-quote/block-quote';

import listNewBuild from 'components/new-build/list-new-build';
import cardNewBuild from 'components/new-build/card-new-build';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-new-build.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    blockCol2();
    blockTabService();
    blockTabList();
});

//--------------------------------------------------------------------//